<template>
  <Container :list="this.$nav8" title="历年分数"  v-if="isMaxScreen">
    <div class="pc">
          <div class="breadcrumb">
                <router-link to="/" class="breadcrumb-item">
                  首页
                </router-link>
                -
                <span class="breadcrumb-item">
                    历年分数
                </span>
          </div>
          <div class="content" v-html="obj.content"></div>
    </div>
  </Container>

  <ResultH5 v-else :obj="obj" />
</template>

<script>
import Container from '@/components/Container/index'
import ResultH5 from '@/views/app/result/index'
export default {
  name: 'lxwm',
  components: { Container, ResultH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      obj: {}

    }
  },
  created () {
    this.getList()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
    })
  },
  methods: {
    async getList () {
      const data = await this.$get('/ow/article/' + 296)
      this.obj = data
    }
  }
}
</script>

<style lang="scss" scoped>
.pc {
  .content{
    font-size: 16px;
    text-indent: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    ::v-deep p {
      text-align: left!important;
      line-height: 2.5;
      text-indent: 0!important;
    }
    ::v-deep img {
      max-width: 100%!important;
    }
  }
}
</style>
